import { useNavigate } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { KemyoonLogo } from '@/components/KemyoonLogo'

export function TermsOfUsePage() {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 bg-background/95 backdrop-blur border-b z-10">
        <div className="px-3 py-3 flex items-center gap-2">
          <Button variant="ghost" size="icon" onClick={() => navigate(-1)}>
            <ArrowLeft className="h-5 w-5" />
          </Button>
          <h1 className="font-semibold">Terms of Use</h1>
        </div>
      </header>

      <div className="max-w-2xl mx-auto px-6 py-8 space-y-6">
        <div className="text-center mb-8">
          <KemyoonLogo size="md" />
          <p className="text-xs text-muted-foreground mt-2">
            Last updated: April 2026
          </p>
        </div>

        <div className="space-y-5 text-sm text-foreground leading-relaxed">
          <section>
            <h2 className="text-base font-semibold mb-2">
              Acceptance of Terms
            </h2>
            <p>
              By using kemyoon, you agree to these Terms of Use. If you don't
              agree, please don't use the app.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold mb-2">Eligibility</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>You must be at least 13 years old to use kemyoon</li>
              <li>
                You must be a resident of a barangay registered in the system
              </li>
              <li>
                Your account must be verified by your barangay admin to access
                full features
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-base font-semibold mb-2">
              Account Responsibilities
            </h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>Keep your password secure and don't share your account</li>
              <li>Provide accurate and truthful information</li>
              <li>
                Notify your barangay admin if your account is compromised
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-base font-semibold mb-2">Acceptable Use</h2>
            <p>You agree NOT to:</p>
            <ul className="list-disc pl-5 space-y-1 mt-1">
              <li>
                Send harassing, threatening, or abusive messages to other
                residents
              </li>
              <li>Share false information or impersonate others</li>
              <li>Misuse the SOS feature for non-emergencies</li>
              <li>Attempt to access other residents' accounts or data</li>
              <li>
                Spam other users or send unsolicited promotional content
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-base font-semibold mb-2">Content Ownership</h2>
            <p>
              You retain ownership of content you post. By posting, you grant
              kemyoon a license to display and distribute that content within the
              app for community purposes.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold mb-2">Termination</h2>
            <p>
              kemyoon and your barangay admin reserve the right to suspend or
              terminate accounts that violate these terms.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold mb-2">Disclaimer</h2>
            <p>
              kemyoon is provided "as is" without warranties. While we strive
              for reliability, we cannot guarantee uninterrupted service.
              Emergency SOS should not be your only means of contacting
              authorities — always call 911 for life-threatening emergencies.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold mb-2">Changes to Terms</h2>
            <p>
              We may update these terms occasionally. Continued use of the app
              after changes constitutes acceptance of the updated terms.
            </p>
          </section>

          <div className="mt-8 p-4 bg-muted rounded-lg text-xs text-muted-foreground">
            <strong>Note:</strong> This is a placeholder Terms of Use for
            development. A final version reviewed by legal counsel will be
            published before public release.
          </div>
        </div>
      </div>
    </div>
  )
}
